var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_contain_w site_min_w"},[_c('MyTop'),_c('MyHeader'),_c('MyNav'),(_vm.$route.path === '/')?_c('MyMain'):_c('router-view'),_c('MyFooter'),_c('SiteFixedNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }